import type { CSSProperties } from "react";

export type TaxonomyKind = "subject" | "concentration" | "standard";

/**
 * Width for any dialog holding CourseMetaFields, and for the taxonomy editor that
 * opens over it. Wider than the modal default so the Primary category list has room
 * for a title, its type, and the row actions without a horizontal scrollbar. Matching
 * widths keep the panel underneath from peeking out at the sides.
 */
export const COURSE_DIALOG_STYLE: CSSProperties = { width: "min(34rem, 100%)" };

export interface TaxonomyOption {
  id: string;
  title: string;
  shortTitle?: string | null;
  type: string;
  description?: string | null;
  organizationGroupId?: string | null;
  /** Hierarchy (usually a Core). */
  parents?: string[];
  /** Concentration facets. */
  pathways?: string[];
}

export function taxonomyKindLabel(type: string | null | undefined) {
  if (type === "concentration") return "Concentration";
  if (type === "standard") return "Standard";
  return "Core";
}

export function taxonomyKindFromType(type: string | null | undefined): TaxonomyKind {
  if (type === "concentration") return "concentration";
  if (type === "standard") return "standard";
  return "subject";
}

